var behaviorService = (function () {
    function behaviorService() {
    }
    //1，2，3 点击邮件
    //10，11，12 新增场景
    //销售行为
    behaviorService.prototype.RecordNodeInfo = function (parent, s, t, i, d) {
        //http://127.0.0.1/api/recordInfo/getuser
        //{stage:1000,type:1,id:20001,data:{}}   //邮件格式
        //let url = "http://47.96.183.37:9898/api/recordInfo";
        var url = this.baseURL + "/api/recordInfo";
        //if (this.userId >0)
        url += "/" + this.userId;
        parent.isLoaded = false;
        //console.log("parent 1:"+parent.isLoaded);
        if (s == undefined)
            s = 0;
        var data = {
            stage: s,
            type: t,
            infoid: i,
            list: d
        };
        var that = this;
        $.ajax({
            url: url,
            data: data,
            type: "POST",
            dataType: 'json',
            success: function (data) {
                parent.isLoaded = true;
                //console.log("22222===============");
                //console.log("parent.isLoaded :"+parent.isLoaded );
                //console.log(data);
            },
            error: function (er) {
                that.LogErrorInfo(er);
            }
        });
    };
    behaviorService.prototype.LogErrorInfo = function (er) {
        //防止对象为 null
        var errorInfo = {};
        if (er) {
            errorInfo = er;
        }
        var _this = this;
        var messageINfo = {
            userId: _this.userId,
            errorInfo: JSON.stringify(errorInfo)
        };
        var postData = {
            errorMsg: JSON.stringify(messageINfo)
        };
        $.ajax({
            url: "http://139.219.11.127:8080/ddi/exposeoutapi/inserterrormsg",
            type: "POST",
            contentType: 'application/json;charset=utf-8',
            data: JSON.stringify(postData),
            dataType: "JSON",
            success: function (data) {
                if (data.success) {
                    alert("错误信息已经发送,不要重复提交");
                }
            }
        });
    };
    behaviorService.prototype.SaveSolutionQuestion = function (parent, questionId, type, selected, episode) {
        var result = "";
        var len = selected.length;
        for (var i = 0; i < len; i++) {
            if (selected[i].state == 1) {
                if (result.length > 0)
                    result += ",";
                result += i;
            }
        }
        if (result.length > 0) {
            this.RecordNodeInfo(parent, episode, 4, questionId, result);
        }
    };
    behaviorService.prototype.SaveSortQuestionAndAnswer = function (parent, questionId, type, array, options, episode) {
        var result = this.getMultValue(options, array);
        this.RecordNodeInfo(parent, episode, 4, questionId, result);
    };
    behaviorService.prototype.SaveQuestionAndAnswer = function (parent, questionId, type, selectedIndex, selectedMutliChoice, episode) {
        var ar = "";
        var keys = [];
        if (selectedMutliChoice) {
            for (var key in selectedMutliChoice) {
                if (selectedMutliChoice[key]) {
                    keys.push(key);
                    if (ar.length > 0)
                        ar += ",";
                    ar += key + "";
                }
            }
            //ar = JSON.stringify(keys);
            //ar = ar.replace(":true","").replace("\"","");
        }
        console.log("episode:" + ar);
        //sub=1 单选，2=多选 3=判断题  4=排序， 5=单选二型
        if (type == 1 || type == 5) {
            if (selectedIndex > -1)
                this.RecordNodeInfo(parent, episode, 4, questionId, selectedIndex + "");
        }
        else {
            if (ar.length > 0)
                this.RecordNodeInfo(parent, episode, 4, questionId, ar);
        }
    };
    behaviorService.prototype.getInfoId = function (t, i) {
        if (t == 1 || t == 2 || t == 3)
            return i;
        return -1;
    };
    behaviorService.prototype.getMultValue = function (curOption, ar) {
        var result = "";
        for (var k = 0, klen = curOption.length; k < klen; k++) {
            for (var i = 0, len = ar.length; i < len; i++) {
                if (curOption[k] == ar[i]) {
                    if (result.length > 0)
                        result += ",";
                    result += i;
                    break;
                }
            }
        }
        return result;
    };
    return behaviorService;
}());
export { behaviorService };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/behaviorService.ts.pre-build-optimizer.js